import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * UserNameLink — wrap a collaborator name in a click-to-view-timesheet link
 * when the current user has permission. CEO/ADMIN can edit; MANAGER read-only;
 * other roles see plain text.
 *
 * Usage: <UserNameLink user={{ user_id, name }} />
 */
export const UserNameLink = ({ user, fallback = "—", className = "", testid }) => {
  const { user: current } = useAuth();
  if (!user || !user.user_id) return <span className={className}>{user?.name || fallback}</span>;
  const role = current?.role;
  // Only privileged roles get the clickable affordance — MANAGER access will be re-checked
  // server-side (403 if the target user has not worked on any of the manager's missions).
  const can = role === "CEO" || role === "ADMIN" || role === "MANAGER";
  if (!can || user.user_id === current?.user_id) {
    return <span className={className} data-testid={testid}>{user.name}</span>;
  }
  return (
    <Link
      to={`/timesheet?user_id=${user.user_id}`}
      className={`hover:underline hover:text-brand-orange-600 transition-colors ${className}`}
      data-testid={testid || `user-link-${user.user_id}`}
      title={role === "MANAGER" ? "View timesheet (read-only)" : "Open timesheet"}
    >
      {user.name}
    </Link>
  );
};

export default UserNameLink;
